import { QFilterGeneric } from './QFilterGeneric'

export class QFilterAdvanced extends QFilterGeneric {
  name = "advanced_filters";
  class_name = "QFilterAdvanced";
  api_name = 'advanced_filters';
  chip_component = 'ChipAdvancedFilter';

  constructor(value) {
    super(value)
  }

  chip_object() {
    let items = this.value
    return {
      value: items,
      name: this.name,
      readable: null,
      component: this.chip_component
    };
  }
  
  serialize(qfilters) {
    return this.value;
  }

  as_query(qfilters) {
    return {[this.api_name]: encodeURIComponent(JSON.stringify(this.serialize(qfilters)))};
  }
}
